/* eslint-disable @typescript-eslint/no-explicit-any */
import { OrganizationPagination } from 'model/organization';
import { Action } from 'redux';

export const ORGANIZATION_ERROR = 'organization/error';
interface OrganizationErrorAction extends Action<typeof ORGANIZATION_ERROR> {
    payload: {
        error: string;
    };
}

export const ORGANIZATION_CLEAR_ERROR = 'organization/clear_error';
type OrganizationClearErrorAction = Action<typeof ORGANIZATION_CLEAR_ERROR>;

export const ORGANIZATION_CLEAR_SUCCESS = 'organization/clear_success';
type OrganizationClearSuccessAction = Action<typeof ORGANIZATION_CLEAR_SUCCESS>;

export const ORGANIZATION_RESET = 'organization/reset';
type OrganizationResetAction = Action<typeof ORGANIZATION_RESET>;

export const ORGANIZATION_FETCH_START = 'organization/fetch_start';
type OrganizationFetchStartAction = Action<typeof ORGANIZATION_FETCH_START>;

export const ORGANIZATION_FETCH_SUCCESS = 'organization/fetch_success';
interface OrganizationFetchSuccessAction extends Action<typeof ORGANIZATION_FETCH_SUCCESS> {
    payload: {
        organizations: Array<any>;
        pagination?: OrganizationPagination;
    };
}

export const ORGANIZATION_SAVE_START = 'organization/save_start';
type OrganizationSaveStartAction = Action<typeof ORGANIZATION_SAVE_START>;

export const ORGANIZATION_SAVE_SUCCESS = 'organization/save_success';
interface OrganizationSaveSuccessAction extends Action<typeof ORGANIZATION_SAVE_SUCCESS> {
    payload: {
        organization: any;
    };
}

export const ORGANIZATION_DELETE_START = 'organization/delete_start';
type OrganizationDeleteStartAction = Action<typeof ORGANIZATION_DELETE_START>;

export const ORGANIZATION_DELETE_SUCCESS = 'organization/delete_success';
interface OrganizationDeleteSuccessAction extends Action<typeof ORGANIZATION_DELETE_SUCCESS> {
    payload: {
        organizationId: number;
    };
}

export type OrganizationAction =
    | OrganizationErrorAction
    | OrganizationClearErrorAction
    | OrganizationClearSuccessAction
    | OrganizationResetAction
    | OrganizationFetchStartAction
    | OrganizationFetchSuccessAction
    | OrganizationSaveStartAction
    | OrganizationSaveSuccessAction
    | OrganizationDeleteStartAction
    | OrganizationDeleteSuccessAction;
